import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { AuthLink, AuthShell } from "@/components/account/AuthShell";
import { FormError, PasswordField, SubmitButton } from "@/components/account/Field";
import { accountApi, errorMessage } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? "" : "Link non valido: richiedi un nuovo link di recupero.");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8 || form.password !== form.confirm) {
      setError(form.password.length < 8 ? "La password deve avere almeno 8 caratteri." : "Le due password non coincidono.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await accountApi.post("/account/reset-password", { token, password: form.password });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err, "Link non valido o scaduto. Richiedine uno nuovo."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="account-reset-page" lines={["Nuova", "password."]} kicker="Scegline una che ricordi">
      {done ? (
        <div className="space-y-6" data-testid="account-reset-success">
          <CheckCircle2 className="h-10 w-10 text-acid" />
          <p className="font-display text-2xl font-black uppercase leading-tight">Password aggiornata.</p>
          <p className="text-bone/70">Ora puoi accedere con la nuova password.</p>
          <AuthLink to="/account/accedi" testid="account-reset-login-link">Vai all&apos;accesso</AuthLink>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="account-reset-form">
          <PasswordField label="Nuova password (min. 8 caratteri)" required autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="account-reset-password-input" />
          <PasswordField label="Ripeti la password" required autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} testid="account-reset-confirm-input" />
          <FormError error={error} testid="account-reset-error" />
          <SubmitButton loading={loading} testid="account-reset-submit-button" loadingText="Salvo…">Salva password</SubmitButton>
          <p className="border-t border-line pt-6 text-sm text-bone/70">
            Link scaduto? <AuthLink to="/account/password-dimenticata" testid="account-reset-new-link">Richiedine uno nuovo</AuthLink>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
